import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { global_variables } from '../../environments/global_variables';
import { OMNI_30XX_MODAL_TYPE } from '../helpers/sensor-type-names';

const zeroComponent = () => ({ t1: 0, t2: 0, t3: 0, tIdle: 0, tTarget: 0 });
// Matches the config modal's default for a missing T-table row.
const defaultTRow = () => ({ t1: 1, t2: 1, t3: 1, tIdle: 1, tTarget: 1 });
const offValve = () => ({ idleValue: 'off', targetValue: 'off', t1: 0, t2: 'N/A', t3: 0 });

@Injectable({
  providedIn: 'root'
})
export class ConfigDataService {
  private readonly arrStrStepActions = global_variables['stepActions'];
  public missedProps = [];

  constructor() { }

  /**
   * Fill keys missing from an older config. Only an explicit Omni-30xx modalType gets the
   * Omni-30xx backfill; anything else (including no modalType) gets the Omni-2100 one.
   */
  fillDefaultConfigProps(config, modalType?: number) {
    // Report only what this call filled, not what earlier calls on other configs did.
    this.missedProps = [];
    const isOmni30xx = modalType === OMNI_30XX_MODAL_TYPE;
    const updatedConfig = _.cloneDeep(config);
    const currentType = updatedConfig[updatedConfig.Current_Type];
    const currentModeConfig = currentType.Mode_Config;

    for (const currentModeConfigKey in currentModeConfig) {
      if (currentModeConfig.hasOwnProperty(currentModeConfigKey)) {

        const step = currentModeConfig[currentModeConfigKey];
        if (step && step.stepAction === this.arrStrStepActions[0]) {

          // Logic for default missing values:
          if (isOmni30xx) {
            this.fillOmni30xxStep(step);
          } else if (!step.NafionTube) {
            if (!this.missedProps.includes('NafionTube')) {
              this.missedProps.push('NafionTube');
            }
            step.NafionTube = {
              t1: 0,
              t2: 0,
              t3: 0,
              tIdle: 0,
              tTarget: 0
            };
          }
          if (!step.isRepeatedSamplingInRun) {
            if (!this.missedProps.includes('isRepeatedSamplingInRun')) {
              this.missedProps.push('isRepeatedSamplingInRun');
            }
            step.isRepeatedSamplingInRun = false;
          }

          if (!step.Max_Sampling_Time_Per_Step) {
            if (!this.missedProps.includes('Max_Sampling_Time_Per_Step')) {
              this.missedProps.push('Max_Sampling_Time_Per_Step');
            }
            step.Max_Sampling_Time_Per_Step = 0;
          }
        }
        if (step && (step.stepAction === this.arrStrStepActions[0] || step.stepAction === this.arrStrStepActions[2])) {
          if (step.isCleaning === undefined) {
            step.isCleaning = false;
            if (!this.missedProps.includes('isCleaning')) {
              this.missedProps.push('isCleaning');
            }
          }

        }
      }
    }
    return updatedConfig;
  }

  private fillOmni30xxStep(step) {
    if (!step.PID) {
      this.addMissedProp('PID');
      step.PID = defaultTRow();
    }

    if (typeof step.Target_Board_Temp === 'number') {
      // A single temperature becomes the idle/target temperature, as the config modal loads it.
      this.addMissedProp('Target_Board_Temp');
      step.Target_Board_Temp = { ...zeroComponent(), tIdle: step.Target_Board_Temp, tTarget: step.Target_Board_Temp };
    } else if (!_.isPlainObject(step.Target_Board_Temp)) {
      this.addMissedProp('Target_Board_Temp');
      step.Target_Board_Temp = zeroComponent();
    }

    if (!_.isPlainObject(step.Special_Config)) {
      step.Special_Config = {};
    }
    for (const key of ['Valve4', 'PID_Lamp']) {
      if (!step.Special_Config[key]) {
        this.addMissedProp(key);
        // Early Omni-30xx configs kept these at step level; copy them, leaving the originals in place.
        step.Special_Config[key] = step[key] || offValve();
      }
    }
  }

  private addMissedProp(prop: string) {
    if (!this.missedProps.includes(prop)) {
      this.missedProps.push(prop);
    }
  }
}
